/* eslint-disable */
export default (string = '') => {
  if (typeof string !== 'string') return false;
  const regexp = /((http|https):\/\/)?[A-Za-z0-9\.-]{2,}\.[A-Za-z]{2}/;
  return regexp.test(string.trim());
};
/* eslint-enable */
